<template>
  <back-bar-drinks-section class="menu--section-two_column menu--section-back_bar_two_column" :menu="menu" :section="section"
                           :section-modifier="sectionModifier"></back-bar-drinks-section>
</template>

<script lang="ts">
/**
 * Custom component for Back Bar default menu sections.
 *
 * @author Jasper Howard <jhoward@peppermillcas.com>
 * @version 1.1.0
 * @copyright  Copyright (C) 2023-2025, Peppermill Inc. All rights reserved. Redistribution and use in source and binary forms, with or without modification, are not permitted.
 *
 *  2023-12-19 (1.0.0) (jhoward)
 *   - Add <back-bar-drinks-two-column-section> to extend <back-bar-drinks-section>.
 *
 *  2025-04-08 (1.1.0) (jhoward)
 *    - Replace "menuVersion" prop with "menu" prop <back-bar-drinks-two-column-section>.
 *    - Remove "visual_" and "textual_" prefixes from class names in <back-bar-drinks-two-column-section>.
 */

import {defineComponent, PropType} from "vue";
import {Menu, MenuSection} from "../defs";
import BackBarDrinksSection from "./BackBarDrinksSection.vue";

export default defineComponent({
  components: {
    BackBarDrinksSection,
  },
  name: "BackBarDrinksTwoColumnSection",
  props: {
    menu: {
      type: Object as PropType<Menu>,
      required: true
    },
    section: {
      type: Object as PropType<MenuSection>,
      required: true
    },
    sectionModifier: {
      type: String,
      default: ''
    },
  },
})
</script>

<style scoped>
.menu--section-back_bar_two_column:deep(.menu--item_title span:first-child) {
  float: left;
}

.menu--section-back_bar_two_column:deep(.menu--item_price) {
  float: right;
}
</style>